import React, { Component } from 'react'
import Select from 'react-select'
import apiService from '../../services/ApiService'

class Vendors extends Component {
    constructor() {
        super()
        this.state = {
            vendorsList: {},
        }
        this.isComponentStillMounted = true
    }

    componentDidMount() {
        this.getVendorsList()
    }

    componentWillUnmount() {
        this.isComponentStillMounted = false
    }

    getVendorsList = () => {
        apiService.getVendorsDetailList()
            .then(listData => {
                if (listData && this.isComponentStillMounted) {
                     this.setState({
                        vendorsList: listData.data
                    })
                    
                }
            })
            .catch(err => {
                console.error("Error data: ", err)
            })
    }
    

    render() {
        let list = {}
        list = Object.keys(this.state.vendorsList).map((value,index) => {
            
            return {
                label : this.state.vendorsList[value],
                value : value
            }
        })
        list.sort((a,b) => a.label.localeCompare(b.label));

        return (
            <div>
                <Select
                value={this.props.selectedValue}
                placeholder="Select Vendor"
                options={list}
                onChange={(e) => { (e) ? this.props.vendorChange(e) : this.props.vendorChange([])}}
                />
            </div>
        )
    }
}
export default Vendors


// WEBPACK FOOTER //
// ./src/common/DropDowns/Vendors.js